import DataModel from '../../library/proto/data-model'

/**
 * @param {Number} id 該Model的辨識索引
*/

export default class InvoiceAddressModel extends DataModel {
  constructor (args) {
    super(args)
    const entity = args || {}
    this.id = entity.id || 0
    this.sale_territory_code = entity.sale_territory_code || ''
    this.postal_code = entity.postal_code || ''
    this.city = entity.city || ''
    this.district = entity.district || ''
    this.address = entity.address || ''
    this.error_message = ''
  }

  toDatabase (addObject) {
    return {
      sale_territory_code: this.sale_territory_code,
      // postal_code: this.postal_code,
      // city: this.city,
      // district: this.district,
      // address: this.address,
      ...addObject
    }
  }

  rules () {
    return {
      postal_code: {
        presence: {
          allowEmpty: false,
          message: '^請填寫郵遞區號'
        },
        length: {
          minimum: 3,
          tooShort: '^郵遞區號最少3碼',
          maximum: 6,
          tooLong: '^郵遞區號最多6碼'
        },
        words: {
          test: /[0-9]/,
          message: '^僅能輸入數字'
        }
      },
      city: {
        presence: {
          allowEmpty: false,
          message: '^請填寫城市'
        }
      },
      district: {
        presence: {
          allowEmpty: false,
          message: '^請填寫地區'
        }
      },
      address: () => {
        console.log('address', this.address)
        if (this.postal_code === '' && this.city === '' && this.district === '' && this.address === '') {
          return { inclusion: { message: '^請確實填寫收貨地址' } }
          // eslint-disable-next-line no-control-regex
        } else if (this.address === '') {
          return { inclusion: { message: '^請確實填寫收貨地址' } }
          // eslint-disable-next-line no-control-regex
        } else if (!this.address.match(/^(\w|[\u4E00-\u9FA5()-])*$/)) {
          return { inclusion: { message: '^請確實填寫收貨地址，勿填入特殊符號 (限半形，中英文及數字還有括弧)\n' } }
        }
        if (this.errors) {
          if (this.errors.postal_code) {
            return { inclusion: { message: `^${this.errors.postal_code}` } }
          }
          if (this.errors.city) {
            return { inclusion: { message: `^${this.errors.city}` } }
          }
          if (this.errors.district) {
            return { inclusion: { message: `^${this.errors.district}` } }
          }
        }
        return {
          presence: {
            allowEmpty: false,
            message: '^請確實填寫收貨地址'
          }
          // words: {
          //   test: /[\u4E00-\u9FA5]|[a-zA-Z]|[0-9]|[、]|[_]|\(|\)/,
          //   message: '^僅能輸入中文、英文、數字，符號僅能 (、)'
          // }
        }
      }
    }
  }
}
